import { useParams } from "react-router-dom";
import ProductSection from "../components/ProductSection";
import { productDetails } from "../data";
import { Link } from "react-router-dom";


function ProductDetail() {
  const { productName } = useParams();
  const selectedProduct = productDetails[productName];

  if (!selectedProduct) {
    return <p>Product not found</p>;
  }

  return (
    <div className="container max-w-3xl mx-auto py-10">
      <h1 className="text-3xl font-bold text-center mb-6">{selectedProduct.title}</h1>
      <div className="mb-10">
        <ProductSection title={`About ${selectedProduct.title}`} content={selectedProduct.about} />
        <ProductSection title="How to Play" content={selectedProduct.howToPlay} />
        {/* <ProductSection title={`${selectedProduct.title} Terms and Conditions`} content={selectedProduct.termsAndConditions} /> */}
        <Link to={`terms`} className="text-blue-500 text-xl font-semibold">View Terms and Conditions &#8594;</Link>
      </div>
  </div>
  );
}

export default ProductDetail;
